import { render, staticRenderFns } from "./PeopleFunded.vue?vue&type=template&id=7e7fe636&"
import script from "./PeopleFunded.vue?vue&type=script&lang=js&"
export * from "./PeopleFunded.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports